import Layout from '@/layout';
import routerView from "@/components/otherTpl/routerView";

// 工程
export default {
    path: '/engineer',
    component: Layout,
    redirect: '/engineer/communityManage/index',
    alwaysShow: true,
    meta: {
        title: '工程',
        icon: 'menu_gc',
        modules: [18000]
    },
    children: [
        // 社区管理
        {
            path: 'communityManage',
            redirect: '/engineer/communityManage/index',
            component: routerView,
            meta: {
                title: '社区管理',
                modules: [18001]
            },
            children: [{
                path: 'index',
                name: 'CommunityManageAdminList',
                component: () => import('@/views/engineer/communityManage/index'),
                meta: {
                    breadcrumb: false,
                    title: '社区管理',
                    icon: 'spot',
                    keepAlive: true,
                    modules: [18001]
                }
            },
            {
                path: 'communityDetail/:id',
                name: 'CommunityAdminDetail',
                hidden: true,
                component: () => import('@/views/engineer/communityManage/communityDetail'),
                meta: {
                    title: '社区管理详情',
                    activeMenu: '/engineer/communityManage/index',
                    modules: [18001]
                }
            }
            ]
        },
        // 成员管理
        {
            path: 'memberManage',
            redirect: '/engineer/memberManage/index',
            component: routerView,
            meta: {
                title: '成员管理',
                modules: [18003]
            },
            children: [{
                path: 'index',
                name: 'MemberManageList',
                component: () => import('@/views/engineer/memberManage/index'),
                meta: {
                    breadcrumb: false,
                    title: '成员管理',
                    icon: 'spot',
                    keepAlive: true,
                    modules: [18003]
                }
            },
            {
                path: 'memberDetail/:id',
                name: 'MemberDetail',
                hidden: true,
                component: () => import('@/views/engineer/memberManage/memberDetail'),
                meta: {
                    title: '成员管理详情',
                    activeMenu: '/engineer/memberManage/index',
                    modules: [18003]
                }
            }
            ]
        },
        // 任务管理
        {
            path: 'taskupManage',
            redirect: '/engineer/taskupManage/index',
            component: routerView,
            meta: {
                title: '任务管理',
                modules: [18005]
            },
            children: [
                // 任务管理
                {
                    path: 'index',
                    name: 'TaskupManageList',
                    component: () => import('@/views/engineer/taskupManage/index'),
                    meta: {
                        breadcrumb: false,
                        title: '任务管理',
                        icon: 'spot',
                        keepAlive: true,
                        modules: [18005]
                    }
                },
                // 任务详情
                {
                    path: 'taskUpDetail/:id',
                    name: 'TaskUpDetail',
                    hidden: true,
                    component: () => import('@/views/engineer/taskupManage/taskUpDetail'),
                    meta: {
                        title: '任务详情',
                        activeMenu: '/engineer/taskupManage/index',
                        modules: [18005]
                    }
                }
            ]
        },
        // 报修管理
        {
            path: 'repairManage',
            redirect: '/engineer/repairManage/index',
            component: () => import('@/components/otherTpl/routerView'),
            meta: {
                title: '报修管理',
                modules: [18006]
            },
            children: [
                // 报修管理
                {
                    path: 'index',
                    name: 'RepairManageList',
                    component: () => import('@/views/engineer/repairManage/index'),
                    meta: {
                        breadcrumb: false,
                        title: '报修管理',
                        icon: 'spot',
                        keepAlive: true,
                        modules: [18006]
                    }
                },
                // 报修详情
                {
                    path: 'mediaRepairDetail',
                    name: 'MediaRepairDetail',
                    hidden: true,
                    component: () => import('@/views/engineer/repairManage/repairDetail'),
                    meta: {
                        title: '报修详情',
                        activeMenu: '/engineer/repairManage/index',
                        modules: [18006]
                    }
                }
            ]
        },
        // 工程工具箱
        {
            path: 'toolBox',
            component: routerView,
            redirect: '/engineer/toolBox/index',
            meta: {
                title: '工程工具箱',
                icon: 'spot',
                modules: [18008]
            },
            children: [
                {
                    path: 'index',
                    name: 'EngineerToolBox',
                    component: () => import('@/views/engineer/toolBox/index'),
                    meta: {
                        breadcrumb: false,
                        title: '工程工具箱',
                        modules: [18008]
                    }
                },
                {
                    path: 'taskupStatistics',
                    name: 'TaskupStatistics',
                    hidden: true,
                    component: () => import('@/views/engineer/toolBox/taskupStatistics'),
                    meta: {
                        title: '上刊情况',
                        activeMenu: '/engineer/toolBox/index',
                        modules: [18103]
                    }
                },
                {
                    path: 'takeStatistics',
                    name: 'TakeStatistics',
                    hidden: true,
                    component: () => import('@/views/engineer/toolBox/takeStatistics'),
                    meta: {
                        title: '拍照情况',
                        activeMenu: '/engineer/toolBox/index',
                        modules: [18104]
                    }
                },
                {
                    path: 'taskImplementSituation',
                    name: 'TaskImplementSituation',
                    hidden: true,
                    component: () => import('@/views/engineer/toolBox/taskImplementSituation'),
                    meta: {
                        title: '任务执行情况',
                        activeMenu: '/engineer/toolBox/index',
                        modules: [18023]
                    }
                },
                {
                    path: 'handoverCharge',
                    name: 'HandoverCharge',
                    hidden: true,
                    component: () => import('@/views/engineer/toolBox/handoverCharge'),
                    meta: {
                        title: '工程负责人交接',
                        activeMenu: '/engineer/toolBox/index',
                        modules: [18024]
                    }
                },
                // 原图管理
                {
                    path: 'originalManage',
                    redirect: '/engineer/toolBox/originalManage/originalManageList',
                    hidden: true,
                    component: () => import('@/components/otherTpl/routerView'),
                    meta: {
                        title: '原图管理',
                        modules: [18007]
                    },
                    children: [
                        // 原图管理
                        {
                            path: 'originalManageList',
                            name: 'OriginalManageList',
                            component: () => import('@/views/engineer/toolBox/originalManage/index'),
                            meta: {
                                breadcrumb: false,
                                title: '原图管理',
                                activeMenu: '/engineer/toolBox/index',
                                keepAlive: true,
                                modules: [18007]
                            }
                        },
                        // 原图详情
                        {
                            path: 'originalDetail/:id/:time',
                            name: 'OriginalDetail',
                            hidden: true,
                            component: () => import('@/views/engineer/toolBox/originalManage/originalDetail'),
                            meta: {
                                title: '原图详情',
                                activeMenu: '/engineer/toolBox/index',
                                modules: [18007]
                            }
                        }
                    ]
                },
                // 印刷信息
                {
                    path: 'printInfo',
                    redirect: '/engineer/toolBox/printInfo/printInfoList',
                    hidden: true,
                    component: () => import('@/components/otherTpl/routerView'),
                    meta: {
                        title: '印刷信息',
                        modules: [18009]
                    },
                    children: [
                        // 印刷信息
                        {
                            path: 'printInfoList',
                            name: 'PrintInfoList',
                            component: () => import('@/views/engineer/toolBox/printInfo/index'),
                            meta: {
                                breadcrumb: false,
                                title: '印刷信息',
                                activeMenu: '/engineer/toolBox/index',
                                keepAlive: true,
                                modules: [18009]
                            }
                        }

                    ]
                },
                {
                    path: 'engInstallSheet',
                    component: routerView,
                    hidden: true,
                    redirect: '/engineer/toolBox/engInstallSheet/index',
                    meta: {
                        title: '安装单',
                        modules: [18011]
                    },
                    children: [
                        {
                            path: 'index',
                            name: 'EngInstallSheet',
                            component: () => import('@/views/engineer/toolBox/engWorking/engInstallSheet/index'),
                            meta: {
                                breadcrumb: false,
                                title: '安装单',
                                activeMenu: '/engineer/toolBox/index',
                                keepAlive: true,
                                modules: [18011]
                            }
                        },
                        {
                            path: 'details/:id',
                            name: 'engInstallDetails',
                            hidden: true,
                            component: () => import('@/views/engineer/toolBox/engWorking/engInstallSheet/installDetail'),
                            meta: {
                                title: '安装单详情',
                                activeMenu: '/engineer/toolBox/index',
                                modules: [18011]
                            }
                        }
                    ]
                },
                {
                    path: 'engDemoliSheet',
                    component: routerView,
                    hidden: true,
                    redirect: '/engineer/toolBox/engDemoliSheet/index',
                    meta: {
                        title: '拆除单',
                        modules: [18012]
                    },
                    children: [
                        {
                            path: 'index',
                            name: 'EngDemoliSheet',
                            component: () => import('@/views/engineer/toolBox/engWorking/engDemoliSheet/index'),
                            meta: {
                                breadcrumb: false,
                                title: '拆除单',
                                activeMenu: '/engineer/toolBox/index',
                                keepAlive: true,
                                modules: [18012]
                            }
                        },
                        {
                            path: 'details/:id',
                            name: 'engDemoliDetails',
                            hidden: true,
                            component: () => import('@/views/engineer/toolBox/engWorking/engDemoliSheet/engDemoliDetail'),
                            meta: {
                                title: '拆除单详情',
                                activeMenu: '/engineer/toolBox/index',
                                modules: [18012]
                            }
                        }
                    ]
                },
                {
                    path: 'communityHandover',
                    name: 'CommunityHandover',
                    hidden: true,
                    component: () => import('@/views/engineer/toolBox/communityHandover'),
                    meta: {
                        title: '工程人员社区交接',
                        activeMenu: '/engineer/toolBox/index',
                        keepAlive: true,
                        modules: [18105]
                    }
                },
                {
                    path: 'installApp',
                    name: 'InstallApp',
                    hidden: true,
                    component: () => import('@/views/engineer/toolBox/installApp'),
                    meta: {
                        title: '特工组安装',
                        activeMenu: '/engineer/toolBox/index',
                        keepAlive: true,
                        modules: [18106]
                    }
                }
            ]
        }
    ]
};
